/**
 * Pause Icon Component
 *
 * Pause icon with official toolkit sizes.
 *
 * @module @smoothie-framework/ui/icons/pause-icon
 */
import { createIconNode } from '../create-icon';
const PAUSE_ICON = Object.freeze({
    sm: {
        viewBox: '0 0 16 16',
        paths: [
            { d: 'M5.5 1.5H3.5C2.94772 1.5 2.5 1.94872 2.5 2.501V13.499C2.5 14.0513 2.94772 14.5 3.5 14.5H5.5C6.05228 14.5 6.5 14.0513 6.5 13.499V2.501C6.5 1.94872 6.05228 1.5 5.5 1.5Z', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round' },
            { d: 'M12.5 1.5H10.5C9.94772 1.5 9.5 1.94772 9.5 2.5V13.5C9.5 14.0523 9.94772 14.5 10.5 14.5H12.5C13.0523 14.5 13.5 14.0523 13.5 13.5V2.5C13.5 1.94772 13.0523 1.5 12.5 1.5Z', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round' },
        ],
    },
    md: {
        viewBox: '0 0 24 24',
        paths: [
            { d: 'M9.5 4.5H7.5C6.94772 4.5 6.5 4.94849 6.5 5.50078V18.4992C6.5 19.0515 6.94772 19.5 7.5 19.5H9.5C10.0523 19.5 10.5 19.0523 10.5 18.5V5.5C10.5 4.94772 10.0523 4.5 9.5 4.5Z', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round' },
            { d: 'M16.5 4.5H14.5C13.9477 4.5 13.5 4.94772 13.5 5.5V18.5C13.5 19.0523 13.9477 19.5 14.5 19.5H16.5C17.0523 19.5 17.5 19.0523 17.5 18.5V5.5C17.5 4.94772 17.0523 4.5 16.5 4.5Z', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round' },
        ],
    },
});
export function PauseIcon(props) {
    return createIconNode(PAUSE_ICON, props);
}
//# sourceMappingURL=pause.js.map